import { FocusMonitor } from "@angular/cdk/a11y";
import { Directionality } from "@angular/cdk/bidi";
import { NgFor, NgIf, NgTemplateOutlet } from "@angular/common";
import { ChangeDetectorRef, Component, ElementRef, Input, Optional, TemplateRef, forwardRef } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { NzCheckBoxOptionInterface, NzCheckboxGroupComponent } from "ng-zorro-antd/checkbox";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { UiCheckboxComponent } from "../../checkbox.component";

export type UiCheckBoxOptionInterface = NzCheckBoxOptionInterface;

@Component({
  selector: "ui-checkbox-group",
  exportAs: "uiCheckboxGroup",
  templateUrl: "checkbox-group.component.html",
  styleUrls: ["checkbox-group.component.less"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UiCheckboxGroupComponent),
      multi: true,
    },
  ],
  host: {
    "[class.ant-checkbox-group-disabled]": "nzDisabled",
    "[style.flex-direction]": "uiDirection",
  },
  standalone: true,
  imports: [NgIf, UiCheckboxComponent, NgTemplateOutlet, NgFor],
})
export class UiCheckboxGroupComponent extends NzCheckboxGroupComponent {
  @Input("uiDisabled") @InputBoolean() public nzDisabled = false;
  @Input() public uiGroupLabel = "";
  @Input() public uiGroupLabelPosition: "top" | "left" = "top";
  @Input() public uiDirection?: "row" | "column" = "column";
  @Input("uiLabelTemplate") public uiLabelTemplate: TemplateRef<void>;

  constructor(elementRef: ElementRef, focusMonitor: FocusMonitor, cdr: ChangeDetectorRef, @Optional() directionality: Directionality) {
    super(elementRef, focusMonitor, cdr, directionality);
  }
}
